<template>
    <div>
        <div v-if="success" class="alert alert-info">{{ success }}</div>
        <div v-if="error" class="alert alert-danger">Er is iets misgegaan. Controleer a.u.b. uw gegevens.</div>
        <form method="post" class="bg-orange-light p-5 mt-5">
            <p>Dien hier uw incasso in</p>
            <div class="form-group" :class="{ 'has-invalid': $v.name.$error }">
                <label for="name">Uw naam</label>
                <input type="text" class="form-control" id="name" name="name"
                       v-model.trim.lazy="$v.name.$model"
                       @focus="$v.name.$reset(); clearMsg()">
                <label v-if="$v.name.$error">
                    <small>
                        {{ $v.name.$error && !$v.name.maxLength ? 'U gebruikt te veel tekens.' : '' }}
                    </small>
                </label>
            </div>
            <div class="form-group" :class="{ 'has-invalid': $v.contact.$error }">
                <label for="contact">E-mailadres of telefoonnummer</label>
                <input type="text" class="form-control" id="contact" name="contact"
                       v-model.trim.lazy="$v.contact.$model"
                       @focus="$v.contact.$reset(); clearMsg()">
                <label v-if="$v.contact.$error">
                    <small>
                        {{ $v.contact.$error && !$v.contact.maxLength ? 'U gebruikt te veel tekens.' : '' }}
                    </small>
                </label>
            </div>
            <!-- factuur/facturen  -->
            <div class="form-group">
                <div class="input-group input-group-file">
                    <div class="custom-file">
                        <input type="file" multiple name="invoice-files" id="invoice-files"
                               accept="application/pdf, application/msword, image/jpg, image/jpg, image/png"
                               class="custom-file-input custom-select"
                               @change="invoiceFilesHandler">
                        <label for="invoice-files" data-content="Bestand kiezen" data-action="Bladeren"
                               class="custom-file-label" v-html="invoiceFileLabel"></label>
                    </div>
                </div>
            <!-- aanmaning(en) -->
            </div>
            <div class="form-group">
                <div class="input-group-append input-group-file">
                    <div class="custom-file">
                        <input type="file" multiple name="reminder-files" id="reminder-files"
                               accept="application/pdf, application/msword, image/jpg, image/jpg, image/png"
                               class="custom-file-input custom-select"
                               @change="reminderFilesHandler">
                        <label for="reminder-files" data-content="Bestand kiezen" data-action="Bladeren"
                               class="custom-file-label" v-html="reminderFileLabel"></label>
                    </div>
                </div>
            </div>
            <div class="form-group" :class="{ 'has-invalid': $v.remarks.$error }">
                <label for="remarks">Bijzonderheden</label>
                <textarea class="form-control" id="remarks" name="remarks"
                          v-model.trim.lazy="$v.remarks.$model"
                          @focus="$v.remarks.$reset(); clearMsg()"></textarea>
                <label v-if="$v.remarks.$error">
                    <small>
                        {{ $v.remarks.$error && !$v.remarks.maxLength ? 'U gebruikt te veel tekens.' : '' }}
                    </small>
                </label>
            </div>
            <!-- geen geen type = submit doen-->
            <div class="row">
                <div class="col-6 offset-6">
                    <button type="button" class="btn btn-primary btn-block mb-4" :class="{ 'btn-spinner' : processing}" @click="submit($event)">
                        <spinner v-if="processing" :color="'#fdccaf'" class="d-inline-block"></spinner>
                        <template v-else> Incasseer</template>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Spinner from 'vue-spinner-component/src/Spinner.vue';
import {required, maxLength} from 'vuelidate/lib/validators';

export default {
    components: {
        Spinner,
    },
    props: {
        route: String
    },
    data() {
        return {
            name: null,
            contact: null,
            remarks: null,
            invoiceFiles: [],
            reminderFiles: [],

            processing: false,
            success: '',
            error: null,
        }
    },
    validations() {
        return {
            name: {
                required,
                maxLength: maxLength(255)
            },
            contact: {
                required,
                maxLength: maxLength(255)

            },
            remarks: {
                maxLength: maxLength(10000)
            }
        }
    },
    computed: {
        invoiceFileLabel() {
            if (this.invoiceFiles.length > 1) {
                return this.invoiceFiles.length + ' bestanden'
            }

            if (this.invoiceFiles.length === 1) {
                return this.invoiceFiles[0].name;
            }

            return 'Factuur/facturen';
        },
        reminderFileLabel() {

            if (this.reminderFiles.length > 1) {
                return this.reminderFiles.length + ' bestanden'
            }

            if (this.reminderFiles.length === 1) {
                return this.reminderFiles[0].name;
            }

            return 'Aanmaning(en)';
        }
    },
    methods: {
        clearMsg() {
            this.success = '';
            this.error = false;
        },
        invoiceFilesHandler(e) {
            this.invoiceFiles = e.target.files || e.dataTransfer.files;
        },
        reminderFilesHandler(e) {
            this.reminderFiles = e.target.files || e.dataTransfer.files;
        },
        submit(event) {

            event.currentTarget.blur();

            this.$v.$touch();

            if (!this.$v.$invalid && !this.processing) {
                this.processing = true;

                let data = new FormData();

                data.append('name', this.name);
                data.append('contact', this.contact);
                data.append('remarks', this.remarks);
                _.each(this.invoiceFiles, (file, i) => { data.append('invoiceFiles[' + i + ']', file) });
                _.each(this.reminderFiles, (file, i) => { data.append('reminderFiles[' + i + ']', file) });

                this.axios
                    .post(this.route, data)
                    .then(r => {
                        this.success = r.data.success;
                        this.error = false;

                        this.invoiceFiles = this.reminderFiles = [];
                        this.name = this.contact = this.remarks = '';
                        this.$v.$reset();
                    })
                    .catch(() => {
                        this.success = '';
                        this.error = true;
                        this.$v.$touch();
                    })
                    .finally(() => {
                        this.processing = false;
                    })
            }
        }
    }
}

</script>

<style scoped>
    .btn {
        display: flex;
        justify-content: center;
    }
    .btn-spinner {
        padding: .75rem;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/components/Dienstenformulier.vue